
export class StatusMessageHelper {
    private static secondsToAutoCloseStatusMessages: number = 5 * 1000; // 5 seconds

    public static initValidator(): void {
        jQuery.validator.setDefaults({
            highlight: (element: any) => {
                jQuery(element).closest('.form-group').addClass('has-error');
            },
            unhighlight: (element: any) => {
                jQuery(element).closest('.form-group').removeClass('has-error');
            },
            errorElement: 'span',
            errorClass: 'label label-danger',
            errorPlacement: (error: any, element: any) => {
                if (element.parent('.input-group').length) {
                    error.insertAfter(element.parent());
                } else {
                    error.insertAfter(element);
                }
            }
        });
    }

    public static initSatusMessage(): void {
        var statusMessagesToAutoClose = $('div[data-componentType="statusMessage"][data-autoClose="true"]');
        if (statusMessagesToAutoClose.length > 0) {
            setTimeout(() => {
                statusMessagesToAutoClose.fadeOut('slow', function () {
                    $(this).remove();
                });
            }, this.secondsToAutoCloseStatusMessages);
        }

        var statusMessageCloseBtns = $('div[data-componentType="statusMessage"] button.close');
        statusMessageCloseBtns.on('click', (e) => {
            var btn = $(e.target);
            var panel = btn.parent('[data-componentType="statusMessage"]');
            panel.remove();
        });
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Utils/StatusMessageHelper.ts
 **/